import React, {useState} from 'react';
import './App.css';

const api = {
  key: "510f81dbbc4e994e5498b4f37d0e7df7",
  base: "https://api.openweathermap.org/data/2.5/",
}

function App() {
  const [query, setQuery] = useState('');
  const [weather, setWeather] = useState({});
  const search = (evt) => {
    if (evt.key === "Enter" || evt.key === 13) {
      fetch(`${api.base}weather?q=${query}&units=metric&APPID=${api.key}`)
        .then(res => res.json())
        .then(result => {
          setWeather(result);
          setQuery('');
          });
    }
  }

  const today = new Date();
  const day = today.toDateString();
  return (
    <div className={(typeof weather.main != "undefined") ? ((weather.main.temp > 20) ? 'App warm' : 'App') : 'App'}>
    <h1 className="header">Daily Weather</h1>
      <main>
        <div className="search-box">
          <input 
          type="text" 
          className="search-bar" 
          placeHolder="Search" 
          onChange={e => setQuery(e.target.value)} 
          value={query} 
          onKeyDown={search} 
          />
        </div>
        {(typeof weather.main != "undefined") ? (
        <div>
        <div className="location-box">
          
          <div className="location">{weather.name}, {weather.sys.country}</div>
          <div className="date">{day}</div>
        </div>
        <div className="weather-box">
          <div className="temp">{Math.round(weather.main.temp)}°C 🌡</div>
          <div className="weather">{weather.weather[0].main}</div>
          <img className="icon" src={"http://openweathermap.org/img/wn/" + weather.weather[0].icon + "@2x.png"} />
          
        </div>
        </div>  
        ) : (<h2 className="intro">Enter a city name</h2>)}
      </main>
    </div>
  );
}

export default App;
